import { useState, useRef, useContext } from 'react';
import './addDocumento.css';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../../authContext';
import AlertsCustom from '../../../../components/Alerts/index'

function InsertModal({ isOpen, onClose, onFileUpload }) {
  const { accessToken, setAccessToken } = useContext(AuthContext);
  const [file, setFile] = useState(null); // Estado para armazenar o arquivo atual
  const [uploadedFiles, setUploadedFiles] = useState([]); // Lista de arquivos enviados
  const [isDragging, setIsDragging] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Controle de carregamento
  const fileInputRef = useRef(null);
  const { t: tDatabase } = useTranslation('database');
  const { t: tCommon } = useTranslation('common');
  const [alertTitle, setAlertTitle] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  if (!isOpen) return null;

  // Captura o arquivo selecionado
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  // Remove o arquivo selecionado
  const removeFile = () => {
    setFile(null);
    fileInputRef.current.value = ''; // Reseta o input
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const droppedFile = event.dataTransfer.files[0]; // Captura o primeiro arquivo arrastado
    setFile(droppedFile);
  };

  // Drag-and-Drop Handlers
  const handleDragOver = (event) => {
    event.preventDefault(); // Necessário para permitir o drop
  };

  const handleDragEnter = () => {
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  // Envia o arquivo para o backend
  const uploadFile = () => {
    if (!file) {
      //alert(tDatabase('select_file'));
      setAlertTitle(tCommon('alertErrorTitle'));
      setAlertType("error")
      setAlertMessage(tDatabase('select_file'))
      setShowAlert(true);
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append('xlsx', file); // Nome esperado pela rota `/insert_excel`

    fetch(`${process.env.REACT_APP_API_URL}/post_insert_excel`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${accessToken}`
      },
      body: formData,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Erro ao enviar o arquivo.');
        }
        return res.json();
      })
      .then(() => {
        //alert(tDatabase('file_sent_successfully'));
        setAlertTitle(tCommon('alertSuccessTitle'));
        setAlertType("success")
        setAlertMessage(tDatabase('file_sent_successfully'))
        setShowAlert(true);
        if (onFileUpload) onFileUpload(file.name);

        // Atualiza a lista de arquivos enviados
        setUploadedFiles((prevFiles) => [...prevFiles, file.name]);
        setFile(null); // Limpa o arquivo após o upload
        onClose(); // Fecha o modal
      })
      .catch((err) => {
        console.error(err);
        setAlertTitle(tCommon('alertErrorTitle'));
        setAlertType("error")
        setAlertMessage(tDatabase('error_sending_file'))
        setShowAlert(true);

      })
      .finally(() => setIsLoading(false)); // Desativa o estado de carregamento
  };

  return (
    <div>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <h2>{tDatabase('add_file')}</h2>
          <p>{tDatabase('document_conflict')}</p>
          <div
            className={`upload-area-addDocumento ${isDragging ? 'dragging' : ''}`}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onClick={() => document.getElementById('file-input').click()}
          >
            <input
              id="file-input"
              type="file"
              accept=".xlsx, .xls" // Apenas arquivos Excel
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            <img src="imagens/upload-icon.svg" alt={tDatabase('uploadIcon')} />
            {file ? (
              <p title={file.name}>
                {file.name.length > 20 ? `${file.name.slice(0, 40)}...` : file.name}
              </p>
            ) : (
              <p>
                {tDatabase('drag_file')} <span className="upload-link">{tDatabase('choose_file')}</span>
              </p>
            )}
          </div>

          {file && (
            <button onClick={removeFile} className="button-remove">
              <div className="file-item">
                <span>
                  {file.name.length > 20 ? `${file.name.slice(0, 40)}...` : file.name}
                </span>
                <img src="/imagens/exclude.svg" alt={tCommon('delete')} className="img-remove" />
              </div>
            </button>
          )}

          <button onClick={uploadFile} disabled={isLoading} className="button-enviar">
            
            {isLoading ? tCommon('sending') : tCommon('send')}
          </button>
          {showAlert && (
              <AlertsCustom
                type={alertType}
                title={alertTitle}
                message={alertMessage}
                onClose={() => setShowAlert(false)}
              />
            )}
        </div>
      </div>
    </div>
  );
}

export default InsertModal;
